export const environment = {
    production: false,
    apiUrl: 'https://api.app.eletroservice.com2.com.br/api',
    appUrl: 'https://api.app.eletroservice.com2.com.br',
    storageBucket: 'https://com2-boatbudget-hmlg.s3.amazonaws.com/product-image/',
  };

export const APP_DATE_FORMATS =
{
      parse: {
          dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
      },
      display: {
          dateInput: 'input',
          monthYearLabel: { year: 'numeric', month: 'numeric' },
          dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
          monthYearA11yLabel: { year: 'numeric', month: 'long' },
      }
};

